/* eslint-disable */
export default {
  ringing: 'Inkomende oproep',
  callConnected: 'Oproep verbonden',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
